import { render, staticRenderFns } from "./TeamManagerEmployeeDetails.vue?vue&type=template&id=6824976c&"
import script from "./TeamManagerEmployeeDetails.vue?vue&type=script&lang=ts&"
export * from "./TeamManagerEmployeeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports